import React, { useState, useEffect, useRef, useCallback } from "react";
import { Rnd } from "react-rnd";
import Config from "../../Config.json";
import classNames from 'classnames';
import {animDropDown, processCSS, handleInputFocus, processHtmlText, hexToRgb, rgbToHex} from "../../utils/form.tools";
import { el } from "date-fns/locale";
import gsap from "gsap";
import { Draggable } from "gsap/all";
import { conforms, isEqual } from 'lodash';
import { apiCall } from "../narrativeUtils/fetch";
import SVG from 'react-inlinesvg';
// import SvgFreehand from "../modules/draw";
import PaperCanvas from "../modules/paper";

// import { ScrollZoomHandler } from "mapbox-gl";
gsap.registerPlugin(Draggable)
function Frame(props) {
  const layerClickCooldownRef = useRef(false);
   const screens = useRef();
    const guidelines = useRef();
    const scrollBar = useRef();
    const handle = useRef();
    const scrollBarHoriz = useRef();
    const handleHoriz = useRef();
    const frameCanvas = useRef();
    const frameElemBox = useRef(null)
    const frameElem = useRef(null);
    const frameZoomElem = useRef(null);
    const selectDrag = useRef(false);
    const isDragging = useRef(false);
    const selectCleared = useRef(false);
    const textEditDiv = useRef();
    const mouseDownListener = useRef();
    const isTypingTimer = useRef();
    const zoomNumberRef = useRef();
    const insetZoomRatioRef = useRef(0);

    // const mouseMoveListener = useRef();
    const mouseUpListener = useRef();
    const selectionListener = useRef();
    const escListener = useRef();
    const editorOn = useRef(null);
    const tempTextObj = useRef();
    const scrollPosY = useRef(0);
    const scrollPosX = useRef(0);


    const [frameDelta, setFrameDelta] = useState(null);
    const [isSelecting, setIsSelecting] = useState(false);
    const [zoomRatio, setZoomRatio] = useState();
    const [initFrame, setInitFrame] = useState(null);
    const [inset, setInset] = useState();
    const [selectSpan, setSelectSpan] = useState();
    const [insetZoomRatio, setInsetZoomRatio] = useState(null);
    const [reRender, setReRender] = useState(0);
    // const [reloadPaper, setReloadPaper] = useState(0);
    // const [frameReady, setFrameReady ] = useState(false);


    
    function handleZoomHeight() {
      let h = frameCanvas.current.offsetHeight + 40;
      frameZoomElem.current.style.height = h + "px";
    }

    function adjustHandle(){
      // console.log('adjustHandle fired')
      let scrollX;
      let scrollY;

    function processDelta(isVert, canvasContainerPos, zoomAreaPos, zoomAreaSize, canvasContainerSize) {
        let scrollPerc = (canvasContainerPos - zoomAreaPos)/canvasContainerSize;
        let scrollPerc2 = (zoomAreaPos + (zoomAreaSize - canvasContainerSize)-canvasContainerPos)/canvasContainerSize;
        // console.log("processDelta", isVert ? "vertical":"horizontal", canvasContainerPos, zoomAreaPos, zoomAreaSize, scrollPerc, scrollPerc2)

        if (scrollPerc > 0.5) {
          scrollPerc = 0.5;
        }
        if (scrollPerc < 0) {
          scrollPerc = 0;
        }
        if (scrollPerc2 > 0.5) {
          scrollPerc2 = 0.5;
        } 
        if (scrollPerc2 < 0) {
          scrollPerc2 = 0;
        }

        return [scrollPerc, scrollPerc2];
      }

      let scrollXPerc;
      let scrollYPerc = [0,0];
      
      if (frameElemBox.current) {
        scrollXPerc = processDelta(false, parseInt(frameElemBox.current.getBoundingClientRect().x), parseInt(frameZoomElem.current.getBoundingClientRect().x), parseInt(frameZoomElem.current.getBoundingClientRect().width), parseInt(frameElemBox.current.getBoundingClientRect().width));

        let scrollYPerc = processDelta(true, parseInt(frameElemBox.current.getBoundingClientRect().y), parseInt(frameZoomElem.current.getBoundingClientRect().y), parseInt(frameZoomElem.current.getBoundingClientRect().height), parseInt(frameElemBox.current.getBoundingClientRect().height))
      
        scrollY = parseInt(scrollBar.current.offsetHeight * scrollYPerc[0]);
      }
      
      if (scrollBarHoriz.current){
        scrollX = parseInt(scrollBarHoriz.current.getBoundingClientRect().width * scrollXPerc[0]);
      }

      scrollPosX.current = scrollX;
      scrollPosY.current = scrollY;

      // console.log('scrollX', scrollX, scrollXPerc)
      // console.log('scrollY', scrollY, scrollYPerc)
      let scrollYHandle = -1;
      let scrollXHandle = -1;

      if (scrollXHandle < 50) {
        scrollXHandle = 50;
      }

   


      if (scrollBar.current) {
          scrollYHandle = parseInt(scrollBar.current.offsetHeight) * (100-parseInt(scrollYPerc[0]*100)-parseInt(scrollYPerc[1]*100))/100;

          if (scrollYHandle >= scrollBar.current.offsetHeight) {
            gsap.to(handle.current, {y: scrollY, height: scrollYHandle, duration: 0, opacity: 0});
          } else {
            gsap.to(handle.current, {y: scrollY, height: scrollYHandle, duration: 0.2, opacity: 1});
          }

          
      }
      if (scrollBarHoriz.current) {
        scrollXHandle = parseInt(scrollBarHoriz.current.offsetWidth) * (100-(parseInt(scrollXPerc[0]*100)+parseInt(scrollXPerc[1] * 100)))/100;

        if (scrollXHandle >= scrollBarHoriz.current.offsetWidth) {
          gsap.to(handleHoriz.current, {x: scrollX, width: scrollXHandle, duration: 0.2, opacity: 0});
        } else {
          gsap.to(handleHoriz.current, {x: scrollX, width: scrollXHandle, duration: 0.2, opacity: 1});
        }

        
      }
      // props.setZoomDelta([parseFloat(scrollX/parseInt(frameElemBox.current.getBoundingClientRect().width)), parseFloat(scrollY/parseInt(frameElemBox.current.getBoundingClientRect().height))])

      // console.log('scrollHandles', parseFloat(scrollX/parseInt(frameElemBox.current.getBoundingClientRect().width)).toFixed(4), parseFloat(scrollY/parseInt(frameElemBox.current.getBoundingClientRect().height)).toFixed(4))
      
      // console.log('scrollX, scrollY', scrollX, scrollY)
      
      runFrameDelta();
    
     
    }

    function onFrameLoad(){
      props.setShowLoader(false);
      setInitFrame([frameZoomElem.current.offsetWidth,frameZoomElem.current.offsetHeight])
    }


    function runFrameDelta(){
      console.log('runFrameDelta', zoomNumberRef.current)
      if (frameElem.current && frameZoomElem.current) {

        // if (frameDelta){
        //     runFrameDelta()
        //     setTimeout(() => {
        //       props.onZoomChoice('fit')
        //     }, 300);
        //   }

        let deltaX = (frameElem.current.getBoundingClientRect().x - frameZoomElem.current.getBoundingClientRect().x)/zoomNumberRef.current;
        let deltaY = (frameElem.current.getBoundingClientRect().y - frameZoomElem.current.getBoundingClientRect().y)/zoomNumberRef.current;

        let deltaX2 =( 0 - frameZoomElem.current.getBoundingClientRect().width)/zoomNumberRef.current;
        let deltaY2 = (0 - frameZoomElem.current.getBoundingClientRect().height)/zoomNumberRef.current;

       

        setFrameDelta([deltaX, deltaY, deltaX2, deltaY2])

        // console.log('deltaX, deltaY, deltaX2, deltaY2', deltaX, deltaY, deltaX2, deltaY2)
      }
      
    }

    useEffect(() => {
    

      Draggable.create(handle.current, {
        type:"y",
        bounds: scrollBar.current,
        edgeResistance: 1,
        onDragStart: function(e) {
          // console.log("drag start", e.y, e);
        },
        onDrag: function(e) {
          let yPosPx = scrollPosY.current - (handle.current.getBoundingClientRect().top - 52);
          let yPerc = yPosPx / scrollBar.current.offsetHeight;
          let offset = frameElemBox.current.getBoundingClientRect().height * yPerc;

          // let offset = frameElemBox.current.getBoundingClientRect().height * yPerc;
          let adjustedOffset = 0;
          if (offset > 0) {
            adjustedOffset = offset + 50
          } else {
            adjustedOffset = offset - 0
          }
          
          // console.log('onDrag', offset, yPerc, yPosPx)
          gsap.to('.canvasPage', {y: adjustedOffset, duration: 0.2})
          // scrollPosY.current = offset
        },
        onDragEnd: function(e) {
          // console.log("drag end", (e.y-51)/scrollBar.current.offsetHeight, e);
        }
      });

      Draggable.create(handleHoriz.current, {
        type:"x",
        bounds: scrollBarHoriz.current,
        edgeResistance: 1,
        onDragStart: function(e) {
          // console.log("drag start", e.y-78);
        },
        onDrag: function(e) {
          
          let xPosPx = scrollPosX.current - (handleHoriz.current.getBoundingClientRect().left - 301);

          let xPerc = xPosPx / scrollBarHoriz.current.offsetWidth;
          let offset = frameElemBox.current.getBoundingClientRect().width * xPerc;
          let adjustedOffset = 0;
          if (offset > 0) {
            adjustedOffset = offset + 50
          } else {
            adjustedOffset = offset - 0
          }
          
          // console.log('onDrag H', xPosPx, handleHoriz.current.getBoundingClientRect().left - frameElem.current.getBoundingClientRect().x)
          gsap.to('.canvasZoom', {x: adjustedOffset, duration: 0.2})

          // scrollPosY.current = offset
        },
        onDragEnd: function(e) {
     
          // console.log("drag end", (e.y-51)/scrollBar.current.offsetHeight, e);
        }
      });

      let canvasDrag = Draggable.create(frameCanvas.current, {
        type:"x,y",
        // bounds: frameElemBox.current, 
      });
      canvasDrag[0].disable();

      function startCanvasDrag(e) {
        if (e.keyCode === 32) {
          canvasDrag[0].enable();
        }
      }

      function stopCanvasDrag(e) {
        if (e.keyCode === 32) {
          canvasDrag[0].disable();
          adjustHandle();
        }
      }

      zoomNumberRef.current = props.zoomNumber

      // Function to be called once the #loading element is gone
      // function onLoadingRemoved() {
      //   console.log('#loading has been removed from the DOM!');
      //   runFrameDelta();
      //   setTimeout(() => {
          
      //     setFrameReady(true)
      //   }, 300);
      // }

      // const observer = new MutationObserver((mutations, obs) => {
      //   if (!document.getElementById('loading')) {
      //     onLoadingRemoved();
      //     obs.disconnect();
      //   }
      // });
      // observer.observe(document.body, { childList: true, subtree: true });


      window.addEventListener('keydown', startCanvasDrag)
      window.addEventListener('keyup', stopCanvasDrag)
   
      
      return () => {
        // setZoomRatio(null);
   
        zoomNumberRef.current = 1
      }

    }, [])

    useEffect(() => {
      if (props.reloadFrame > 0) {
        //  setTimeout(() => {
        //   let curr = reRender;
        //   setReRender(curr+=1);
        // }, 300);
      }
    }, [props.reloadFrame])



    useEffect(() => {
      if (props.loading && props.zoomRatio) {
        let curr = reRender;
        console.log('curr',curr+=1)
        setTimeout(() => {
          setReRender(curr+=1);
        }, 300);
       
      }
    }, [props.loading, props.zoomRatio])

  
useEffect(() => {
 console.log('key test', props.test)
}, [props.test])


    useEffect(() => {
      if (props.zoomNumber && frameZoomElem.current && frameElem.current && props.componentDimensions && props.activeSectionObj) {

        
        if (zoomNumberRef.current !== props.zoomNumber) {
          zoomNumberRef.current = props.zoomNumber
          // console.log("props.zoomNumber", props.zoomNumber, zoomNumberRef.current)
          gsap.to(frameZoomElem.current, {scale: props.zoomNumber, duration: 0.3, onComplete: () => {
              adjustHandle()
          }})
        } else {
          // console.log("props.zoomNumber unchanged", props.zoomNumber, zoomNumberRef.current)
          setTimeout(() => {
            gsap.to(frameZoomElem.current, {scale: props.zoomNumber, duration: 0, onComplete: () => {
              adjustHandle()
        
            }})
          }, 300);
      
         
        }
    
        // console.log('Frame zoomNumber', props.zoomNumber, zoomNumberRef.current, zoomRatio)
      
    }
  }, [props.zoomNumber, props.componentDimensions, props.activeSectionObj])

    useEffect(() => {
      if (props.activeSettingId) {
   
        setSelectSpan(null)
        props.setSelection(null)
        props.setTempText(null)
        
      }

    }, [props.activeSettingId])


    useEffect(() => {

      if (props.activeSectionObj && props.activeDisplay && frameElem.current) {
        props.setShowLoader(false)
        console.log('frameElem Rendered')
        let heightDiff = frameElem.current.offsetHeight/props.activeDisplay.height_px;
        setZoomRatio(heightDiff);
        console.log('setting Zoom Ratio', heightDiff, frameElem.current.offsetHeight)
        
    
      } 
    }, [props.activeSectionObj, props.activeDisplay])



    useEffect(() => {

      if (props.activeDisplay && props.narrative.insets) {


       

        let insetObj = props.narrative.insets.filter(a => a.display === props.activeDisplay.id);
        // console.log('insetObj', insetObj, props.narrative.insets)
        if (insetObj) {
          setInset(insetObj[0]);
          let elemHeight;
          setTimeout(() => {
            let elemHeightObj = document.getElementById('bounds');
            if (elemHeightObj) {
              elemHeight = elemHeightObj.offsetWidth - 2;
              let ratio = elemHeight / props.activeDisplay.width_px
              // console.log('setInsetZoomRatio', ratio, elemHeight, props.activeDisplay.width_px)
              setInsetZoomRatio(ratio)
              setTimeout(() => {
                console.log('running runFrameDelta')
                runFrameDelta();
              }, 300);
              
            }
            // console.log('inset', insetObj[0])
          }, 150);
          // This timing is too brittle.

     
        }
      }
    }, [props.activeDisplay, props.narrative])

    // useEffect(() => {
    //   console.log("ZOOM RATIO", zoomRatio)
    // }, [zoomRatio])


    function mouseMoveListener() {
      if (!selectDrag.current) {
        selectDrag.current = true
        
      }
      console.log('mousemove')
    }
    
    mouseDownListener.current = () => {
      selectDrag.current = false
    }

    async function clearSelected() {
      console.log('clearSelected')
      props.setSelection(false)
      setSelectSpan(null)
      console.log('props.componentDimensions', props.componentDimensions)

      return true
    }


    mouseUpListener.current = () => {
      console.log('mouseUpListener on')
      clearSelected();
    }

    function getCaretCharacterOffsetWithin(element) {
      var caretOffset = 0;
      var doc = element.ownerDocument || element.document;
      var win = doc.defaultView || doc.parentWindow;
      var sel;
      if (typeof win.getSelection != "undefined") {
          sel = win.getSelection();
          if (sel.rangeCount > 0) {
              var range = win.getSelection().getRangeAt(0);
              var preCaretRange = range.cloneRange();
              preCaretRange.selectNodeContents(element);
              preCaretRange.setEnd(range.endContainer, range.endOffset);
              caretOffset = preCaretRange.toString().length;
          }
      } else if ( (sel = doc.selection) && sel.type !== "Control") {
          var textRange = sel.createRange();
          var preCaretTextRange = doc.body.createTextRange();
          preCaretTextRange.moveToElementText(element);
          preCaretTextRange.setEndPoint("EndToEnd", textRange);
          caretOffset = preCaretTextRange.text.length;
      }
      return caretOffset;
  }




    function getCharacterRangeOfSelection(charOverrides) {
      let id;
      const selection = window.getSelection();      
      const range = selection.getRangeAt(0);  
      const length = range.toString().length;

      console.log('range length', length, range.toString())
 
      let changeArray = []
      if (charOverrides && charOverrides.length > 0) {
        changeArray = [...charOverrides]
      }
      const offsetStartPosition = getCaretCharacterOffsetWithin(selection.baseNode.parentElement.parentElement) - length;
      const offsetEndPosition = getCaretCharacterOffsetWithin(selection.baseNode.parentElement.parentElement);
      // console.log('characterRange selection', selection, offsetStartPosition, offsetEndPosition)

      for (let i = 0; i < offsetEndPosition; i++) {
     
        if (i < offsetStartPosition) {
          // Look for existing character. If it exists, skip it; if no char exists assign 0.
          // console.log('i < startPosition', changeArray[i], i, startPosition)
          if (!changeArray[i]) {
            changeArray[i] = 0
          }
          
        } else {

          if (changeArray[i] && !id) {
            id = [changeArray[i]];
          } else if (changeArray[i] && id) {
            id.push(changeArray[i])
          }  

          if (!changeArray[i] && id) {
            id.push(0)
          }
          if (!changeArray[i] && !id) {
            id = [0];
          }
          
          // Assign Temp 1 to be then given ID of style override 
          // console.log('i >= startPosition', changeArray[i], i, endPosition)
          changeArray[i] = 1
         
        }
     
      }
      let result = {'range': changeArray, 'id': id, 'selectionRange': [offsetStartPosition, offsetEndPosition]};
      
      console.log("getCharacterRangeOfSelection", result)
      
      return result
    }

    function placeSelectSpan(id, selectionRange){
      console.log('placeSelectSpan', id, selectionRange)
      let parent = document.getElementById('dim_text_' + id).getBoundingClientRect();
      // console.log('windowSelection', selection, parent.offsetLeft, selectionRange.getClientRects())
      let rects = selectionRange.getClientRects();
      console.log('rects', rects, selectionRange)
      let spans = [];
      for (const r of rects) {
        spans.push({id: id, style: {position: "absolute", left: r.x - parent.left + "px", top: r.y - parent.top + 0 + "px", width: r.width + "px", height: r.height + 0 + "px"}})
      }
      setSelectSpan(spans)
    }
    

    function onSelectStart(html_text, id, tempText) {
      
      // console.log('onSelectStart', window.getSelection().type )
    
      if (window.getSelection().type === "Range" && !selectDrag.current) {

        if (tempText) {
          html_text = tempText;
        }
        
        clearSelected().then(function() {
          // setIsSelecting(true);
          let selection =  window.getSelection(); 

          if (selection && /\S/.test(selection.toString())) {
            let charOverrides;
          
            if (html_text['charStyleOverrides'] && html_text['charStyleOverrides'].length > 0) {
              charOverrides = html_text['charStyleOverrides']
            }
            // console.log('charOverrides start', charOverrides, props.selection)
            const range = getCharacterRangeOfSelection(charOverrides);
            selectDrag.current = false;
            // console.log('setSelected', range.range, range.id)
            props.setSelection({'range': range.range, 'id': range.id, 'selectionRange': range.selectionRange});

            console.log('selection', selection)
            if (selection.type === "Range") {
              let selectionRange = selection.getRangeAt(0);
              let rangeCopy = selectionRange.cloneRange();
              console.log('rangeCopy', rangeCopy)
              
              placeSelectSpan(id, selectionRange)
            }
            
          } else {
          
            setSelectSpan(null)
          }

        })


        
      }
    }

  // useEffect(() => {
  //   if (props.selection) {
     
  //     console.log('props.selection', props.selection)
  //   }
  // }, [props.selection])



  useEffect(() => {
    // console.log('isSelecting: ', isSelecting)
    if(textEditDiv.current && isSelecting) {
      console.log('isSelecting', isSelecting)
      textEditDiv.current.addEventListener('mousedown', mouseDownListener.current)
      textEditDiv.current.addEventListener('mousemove', mouseMoveListener)
      textEditDiv.current.addEventListener('mouseup',  mouseUpListener.current)

    }
    return () => {
      setSelectSpan(null)
    }

 
  }, [isSelecting, textEditDiv.current])

  useEffect(() => {
   
    if (selectSpan && props.componentDimensions && props.selection) {
      
      setSelectSpan(null)
      props.setSelection(null);
      props.setWindowSelection(null);
    }
  }, [props.componentDimensions, props.selection])

  useEffect(() => {
   

    // console.log('props.updateFetch', props.updateFetch,  props.activeSettingId)
    if (props.updateFetch > -1 && props.activeSectionObj) {
      let url = Config.baseURLcms + "section/" + props.activeSectionObj.id;

      function responseTask(response) {
        let stateImages = [];
        let objs = response.data['components']
        objs.filter(a0 => a0.component !== "statePNGButton").forEach(a => {
          a.dimensions.forEach(b => {
            b.componentdimensionstateimages.forEach(c => {
              stateImages.push(c)
            })
          });
        })
        props.setStateImages(stateImages);

  
      }
      apiCall('get', url, {}, responseTask, null, props.setFormError)
    }
  }, [props.updateFetch, props.activeSectionObj])
    


    function handleCanvasClick(e) {
        let classes = e.target.classList;

        // editorOn.current = false;
        
        if (classes.contains("clearBtn")) {
          editorOn.current = false;
          
          clearSelected().then(function(){

            // console.log('handleCanvasClick')

            let curr = reRender;
            console.log('curr',curr+=1)

            //// 2025.06.13: Removed this to correct image shifting for large screens like COG. Not sure if it's used elsewhere.
            // setReRender(curr+=1);
           
            props.setActiveSettingId(null);
            editorOn.current = false;
            props.setDropDown(null);
            props.setSelection(false);
  
            if (isSelecting) {
              setIsSelecting(false);
            }
            
          });
        
        }
    }


    // function delayedUpdateTextOnKeyUp(e) {
    //   clearTimeout(isTypingTimer.current);
    //   if (e) {
    //     isTypingTimer.current = setTimeout(function(){ updateTextOnKeyUp(e) }, 200);
    //   }
    // }

    function extractTextAndStyles(textContent, selection, elementStyle, charIndex, activeStyleObj) {
      // copy from your updateTextOnKeyUp: font-size, color, letter-spacing parsing
      // and return structured data like:
      return {
        text: textContent,
        charStyleOverrides: [],
        styleOverrides: [],
        css: {}
      };
    }

    function handleCopy(e) {
      const selection = window.getSelection();
      const text = selection.toString();
      const baseNode = selection.baseNode;
      const parentElement = baseNode?.parentElement;

      if (!text || !parentElement) return;

      const charIndex = getCaretCharacterOffsetWithin(parentElement.parentElement) - 1;
      const elementStyle = parentElement.style;

      const styleData = extractTextAndStyles(
        text,
        selection,
        elementStyle,
        charIndex,
        {}
      );

      e.clipboardData.setData("application/json", JSON.stringify(styleData));
      e.preventDefault(); // override default plain-text copy
    }

    function handlePaste(e) {
   
      const clipboardData = e.clipboardData.getData("application/json");

      console.log('clipboardData', clipboardData)
      if (clipboardData) {
        const data = JSON.parse(clipboardData);
        // Inject into target div
        props.setTempText(data);
        // Optionally inject styled HTML if needed
        e.preventDefault();
      }
    }
    

    // This is the main function for updating the live text input
    function updateTextOnKeyUp(e) {
      const selection = window.getSelection();

      if (editorOn.current && selection.type !== "Range") {
        const parentElement = selection.baseNode.parentElement;
        const elementStyle = parentElement.style;
        let charIndex = getCaretCharacterOffsetWithin(selection.baseNode.parentElement.parentElement) - 1;

        const activeStyleObj = {};
        // 1. Get Text Content with Line Breaks
        let newText = e.target.textContent;

        console.log('charIndex', charIndex, newText.length)
        
        // 2.Check if the property belongs to the CSSStyleDeclaration instance and ensure that the property is a numeric index (indicating an inline style)
        for (const prop in elementStyle) {
          if (
            Object.hasOwn(elementStyle, prop) &&
            !Number.isNaN(Number.parseInt(prop))
            ){
              if (elementStyle[prop] === 'font-size') {
                let dataFontSize = parentElement.dataset.fontsize;
                let s0 = dataFontSize;
                activeStyleObj[elementStyle[prop]] = parseInt(s0);
              } else if (elementStyle[prop] === 'color') {
                
                let s0 = elementStyle.getPropertyValue(elementStyle[prop]);
                activeStyleObj[elementStyle[prop]] = rgbToHex(s0);
              } else if (elementStyle[prop] === 'touch-action') {
                console.log("pass touch-action: none")
            
              } else {
                activeStyleObj[elementStyle[prop]] = elementStyle.getPropertyValue(elementStyle[prop])
              }

              if (!(elementStyle[prop] === 'letter-spacing')) {
                
                activeStyleObj['letter-spacing'] = 'auto'
            
              } 
             
            }
          }

      

        let newComponents = [ ...props.componentDimensions ];
        let newComponent = newComponents.find(obj => obj.id === props.activeSettingId)
        let newOverides = [];
        let styleOverrides = [];
        let css = {};

        if (newComponent['html_text'] && newComponent['html_text']['css']) {
          css = structuredClone(newComponent['html_text']['css'])
        }

        if (newComponent['html_text']['styleOverrides']|| (props.tempText && props.tempText['styleOverrides'])) {
          if (props.tempText && props.tempText['styleOverrides']) {
            styleOverrides = structuredClone(props.tempText['styleOverrides'])
          } else {
            styleOverrides = structuredClone(newComponent['html_text']['styleOverrides'])
          }
        }

        if (newComponent['html_text']['charStyleOverrides'] || (props.tempText && props.tempText['charStyleOverrides'])) {
          if (props.tempText && props.tempText['charStyleOverrides']) {
            newOverides = [ ...props.tempText['charStyleOverrides']]
          } else {
            newOverides = [...newComponent['html_text']['charStyleOverrides']];
          }
        }

        // Add or splice newOverrides with charIndex. This is where existing overrides are extended or shortened.

        if (charIndex > -1 && (newOverides && newOverides.length > 0)) {
          if (e.key === "Backspace" || e.key === "Delete") {
            

            console.log('newOverides[charIndex]', newOverides[charIndex])
            if (newOverides[charIndex]) {
              newOverides.splice(charIndex, 1)
            }
            setSelectSpan(null)
            props.setSelection(null)


          } else {
            if (newOverides[charIndex]) {
              newOverides.splice(charIndex, 0, newOverides[charIndex])
            }
            let newTextLength = 1;
            if (newText && newComponent['html_text'] && newComponent['html_text']['text']) {
              newTextLength = (newText.length - newComponent['html_text']['text'].length);
            } 
            console.log('newTextLength', newTextLength, newComponent['html_text'] && newComponent['html_text']['text'].length)

            let styleObj = styleOverrides.find(a => a.id === newOverides[charIndex-newTextLength]);

            console.log('styleObj, activeStyleObj', styleObj && styleObj.css, activeStyleObj, styleOverrides)

            if ((newOverides[charIndex] === undefined) && (styleObj && isEqual(activeStyleObj, styleObj.css))) {
              newOverides.splice(charIndex, 0, newOverides[charIndex-newTextLength])
              console.log('newOverides: add to index', newOverides, charIndex, newTextLength)
            }
            console.log('newOverides[charIndex]', newOverides[charIndex], newOverides[charIndex-newTextLength], styleObj && isEqual(activeStyleObj, styleObj.css), props.tempText, newOverides)
          }
        }
        props.setTempText({'text': newText, 'charStyleOverrides': newOverides, 'styleOverrides': styleOverrides, 'css': css});
        props.setUnSavedChanges(true);
        console.log('updateEditableText Result', newText, newOverides)
      }


        
          
      }

      function updateTextonKeyDown(e) {
        
         if (e.key === "Backspace" || e.key === "Delete") {
            console.log('updateTextonKeyDown', e)
            setSelectSpan(null)
            props.setSelection(null)
          }
        
      }

      function escClear(){
        isDragging.current = false;
        clearSelected().then(function () {

        console.log('handleEscClick')

        props.setActiveSettingId(null);
        editorOn.current = false;
        props.setDropDown(null);
        selectDrag.current = false;
        // window.removeEventListener('keyPress', escListener.current);
        props.setSelection(false);
        setIsSelecting(false);
        });
      }

      function handleEscClick(e) {
      
        if(e.key === "Escape") {
      
           escClear();
         
        }
      }
    

      function makeTextEditable(elem){
        if (parseInt(elem.id.replace('dim_text_', '')) !== editorOn.current) {
          textEditDiv.current = elem;
          let sel = window.getSelection();
          let range = new Range();
          range.setStart(elem, elem.childNodes.length);
          range.collapse(true);
          sel.removeAllRanges();
          sel.addRange(range)
          elem.focus();
          console.log('makeTextEditable', elem.id, editorOn.current)
        }
        escListener.current = window.addEventListener('keydown', function(e){
          handleEscClick(e)
        })
      }   

      function apiToZoom(value0, isLocked, isBackground, valuePercentage) {
        
       
        let result;
        let value = value0;
        // let x_saved = 
        if (valuePercentage && props.activeDisplay.id !== props.defaultDisplay && inset && inset.inset_x === 0) {
          value = parseFloat(valuePercentage.replace('%', ''))
          result = value + "%"
        } else {
          result = value * zoomRatio 
        }
       
        return result
      }


      function zoomToApi(value, isLocked){
        let result;
        result = value/zoomRatio
        
        return parseInt(result)
      }

      function closeText(){
        console.log('closeText')

        editorOn.current = false;
        
        clearSelected().then(function () {
          editorOn.current = false;
          props.setDropDown(null);
          selectDrag.current = false;
          setIsSelecting(false);
        });
      }

      function openText(dimension){
        if (dimension !== editorOn.current) {
            console.log('openText', dimension)
            editorOn.current = dimension.id;
            tempTextObj.current = dimension.html_text;
            let htmlElem = document.getElementById("dim_text_" + dimension.id)
            console.log('htmlElem', htmlElem)
            if (htmlElem) {
              setTimeout(() => {
                makeTextEditable(htmlElem)
              }, 500);
              
              
            }
        }
       
      }

      useEffect(() => {
        if (props.activeSettingId && props.componentDimensions) {
          console.log('props.activeSettingId', props.activeSettingId, props.componentDimensions)

          let dimensionIndex = props.componentDimensions.findIndex(obj => obj.id === props.activeSettingId);
          // console.log('dI', dimensionIndex)
          if (dimensionIndex > -1) {
            let dimension = props.componentDimensions[dimensionIndex];
            // console.log('d', dimension)
            // Update to listen for only new text layers? 
            if (dimension.html_text && dimension.html_text['text'] === '') {
              setTimeout(() => {
                openText(dimension);
                
              }, 200);
            }



            // if (dimension.html_text && dimension.html_text['text'] !== '') {
            //   setTimeout(() => {
            //     closeText()
            //   }, 100);
            // }
          
          }
        } 
          
      }, [props.activeSettingId, props.componentDimensions])

      

    return(
      <div display={props.activeDisplay.name} className={"canvasContainer clearBtn" + (props.loading === true ? " loading" : "")} onClick={(e) => handleCanvasClick(e)} ref={frameElemBox}>

        {/* Scrollbars */}
        <div className="scrollBar frameScrollBar" ref={scrollBar}>
          <div className="scrollHandle" id="scrollHandle" ref={handle}></div>
        </div>
        <div className="scrollBar frameScrollBarHoriz" ref={scrollBarHoriz}>
          <div className="scrollHandle" ref={handleHoriz}></div>
        </div>

    

        {/* Canvas Area */}
        <div className="canvasPage clearBtn">

 
   

          {/* Canvas Frame */}
          <div ref={frameCanvas} onLoad={() => handleZoomHeight()} id="canvasFormWrap" className={(props.activeSettingId)?("canvasFormWrap inFocus clearBtn"):("canvasFormWrap clearBtn offFocus")}>  


            {/* Canvas Zoom Box */}
            <div className={classNames("canvasZoom","clearBtn")} id="canvasZoom" ref={frameZoomElem} data-zoom={props.zoomNumber} style={{aspectRatio: props.activeDisplay.aspect_ratio}}>


              {/* Guidelines */}
              {inset && frameDelta && zoomRatio && insetZoomRatio && props.activeDisplay && props.zoomNumber && <div className="guidelines" ref={guidelines}>


                <svg className={"guideline"} style={{left: frameDelta[0] + apiToZoom(inset.inset_x, null) + 'px', top: frameDelta[3]}} width={"1px"} height={"1000vh"} ><line x1={0} y1={0} x2={0} y2={"100%"} stroke="#00ffff" strokeWidth="1"/>
                </svg>
                <svg className={"guideline"} style={{left: frameDelta[0] + apiToZoom(inset.inset_width, null) + apiToZoom(inset.inset_x, null) + 'px', top: frameDelta[3]}} width={"1px"} height={"1000vh"} ><line x1={0} y1={0} x2={0} y2={"100%"} stroke="#00ffff" strokeWidth="1"/>
                </svg>
        
                <svg className={"guideline"} style={{left: frameDelta[2], top: frameDelta[1] + apiToZoom(inset.inset_y, null) + 'px' }} width={'1000vw'} height={'1px'} ><line x1={0} y1={0} x2={"100%"} y2={0} stroke="#00ffff" strokeWidth="1"/>
                </svg>

                <svg className={"guideline"} style={{left: frameDelta[2], top: frameDelta[1] + apiToZoom(inset.inset_height, null) + apiToZoom(inset.inset_y, null) + 'px' }} width={'1000vw'} height={'1px'} ><line x1={0} y1={0} x2={"100%"} y2={0} stroke="#00ffff" strokeWidth="1"/>
                  </svg>

                        
                {props.activeDisplay.subdisplays.map( obj => (<svg key={'line_' + obj.id} className={"guideline"} style={{left: frameDelta[0] + apiToZoom(obj.x_pos) + 'px', top: frameDelta[3] + apiToZoom(obj.y_pos) + 'px' }} width={'1px'} height={'1000vw'} ><line x1={0} y1={0} x2={0} y2={"100%"} stroke="#00ffff" strokeWidth="1"/>
                </svg>))}


              </div>}

             
              

              {/* Canvas Box for Active Display Handling */}
              <div className={classNames(
                  "canvasForm",
                  props.showFullCanvas && "showFull",
                  props.isDrawing && "isDrawing"
                )} id={"canvasForm"} ref={frameElem} style={{aspectRatio: props.activeDisplay.aspect_ratio}} >

                {/* Clip Path to Hide Layers Outside of Active Display Box */}
                <div className="clipPath" style={{"position": "relative"}} id="canvasPath">


                {props.isDrawing && <span className="sketchCanvas">
                  <span className="sketchCover"></span>
                  <PaperCanvas 
                    tool={props.isDrawing} 
                    user={props.user} 
                    width={apiToZoom(props.activeDisplay.width_px)} 
                    height={apiToZoom(props.activeDisplay.height_px)} 
                    handleLayerAdded={props.handleLayerAdded}
                    zoomRatio={zoomRatio}
                    zoomNumber={props.zoomNumber}
                    svgPath={null}
                    editing={true}
                    id={props.activeSectionObj.id}
                    activeDisplay={props.activeDisplay}
                    objId={null}
                    updateFetch={props.updateFetch}
                    setUpdateFetch={props.setUpdateFetch}
                    fetchJSON={props.fetchJSON}
                    unSavedChanges={props.unSavedChanges}
                    reRender={reRender}
                    setReloadFrame={props.setReloadFrame}
                    reloadFrame={props.reloadFrame}
                    componentDimensions={props.componentDimensions}
                    setComponentDimensions={props.setComponentDimensions}
                    escClear={escClear}
                    showSettings={props.showSettings}
                    setNewComponentDimension={props.setNewComponentDimension}
                    /> 
                </span>}

                {(props.activeSettingId && props.activeSectionObj && props.componentDimensions.find(a => a.id === props.activeSettingId) && props.componentDimensions.find(a => a.id === props.activeSettingId).file_format === 'svg') && <span 
                  // style={{transform: 'rotate(' + props.componentDimensions.find(a => a.id === props.activeSettingId).rotation + 'deg)'}}
                  className="sketchCanvas" data-id={props.activeSettingId}>
                <span className="sketchCover" onClick={() => escClear()}></span>
                  <PaperCanvas 
                    tool={props.isDrawing} 
                    user={props.user} 
                    width={apiToZoom(props.activeDisplay.width_px)} 
                    height={apiToZoom(props.activeDisplay.height_px)} 
                    objWidth={apiToZoom(props.componentDimensions.find(a => a.id === props.activeSettingId).width)}
                    objHeight={apiToZoom(props.componentDimensions.find(a => a.id === props.activeSettingId).height)}
                    handleLayerAdded={props.handleLayerAdded}
                    zoomRatio={zoomRatio}
                    zoomNumber={props.zoomNumber}
                    svgString={props.componentDimensions.find(a => a.id === props.activeSettingId).svg_string}
                    svgJSON={props.componentDimensions.find(a => a.id === props.activeSettingId).svg_json}
                    x_pos={apiToZoom(props.componentDimensions.find(a => a.id === props.activeSettingId).x_pos)}
                    y_pos={apiToZoom(props.componentDimensions.find(a => a.id === props.activeSettingId).y_pos)}
                    editing={true}
                    id={props.activeSectionObj.id}
                    activeDisplay={props.activeDisplay}
                    objId={props.activeSettingId}
                    fetchJSON={props.fetchJSON}
                    unSavedChanges={props.unSavedChanges}
                    reRender={reRender}
                    setReRender={setReRender}
                    setUnSavedChanges={props.setUnSavedChanges}
                    componentDimensions={props.componentDimensions}
                    setComponentDimensions={props.setComponentDimensions}
                    reloadFrame={props.reloadFrame}
                    rotation={props.componentDimensions.find(a => a.id === props.activeSettingId).rotation}
                    escClear={escClear}
                    showSettings={props.showSettings}
                    setNewComponentDimension={props.setNewComponentDimension}
                    />
                   
                </span>}
    
                  
                  {/* Inset Bounds */}
                  {inset && <span className="bounds" id="bounds" style={{left: apiToZoom(inset.inset_x,null), top: apiToZoom(inset.inset_y,null), width: apiToZoom(inset.inset_width,null) + "px", height: apiToZoom(inset.inset_height,null) + "px", position: 'absolute'}}></span>}

                  {/* Layers */}
                  {zoomRatio && props.componentDimensions && props.componentDimensions
                    .sort((a, b) => a.component_ordering - b.component_ordering)
                    // .filter(file => (file.active === true))
                    .map((dimension, i) => 
                  (dimension) &&
                    (<Rnd
                      key={'draggable_' + dimension.id + "_" + props.activeDisplay.id + "_" + reRender}
                      onClick={(e) => {
                          if (dimension.background||dimension.change_lock||dimension.file_format === 'svg') {

                              // if (layerClickCooldownRef.current) {
                              //   return;
                              // }
                              // // Engage 1s cooldown
                              // layerClickCooldownRef.current = true;
                              // setTimeout(() => {
                              //   layerClickCooldownRef.current = false;
                              // }, 1000);

                            // console.log('e', e)
                            props.showSettings(dimension.id, false, e)
                          }
                      }}
                      onDoubleClick={(e) => {
                        if ((dimension.file_format === "text")&&(dimension.html_text)) {
                          openText(dimension)
                        }
                      }}
                      id={"canvasForm1_draggable_" + dimension.id}
                      className={classNames(
                        !dimension.active && "off"
                      )}
                      position={{
                        x: apiToZoom(dimension.x_pos, dimension.is_locked), 
                        y: apiToZoom(dimension.y_pos, dimension.is_locked)
                      }}

                      size={{
                        width: dimension.background ? "100%":apiToZoom(dimension.width + (dimension.svg_json && dimension.svg_json.objects && dimension.svg_json.objects[0].strokeWidth * props.zoomRatio * 2), dimension.is_locked, dimension.background, dimension.width_perc),  
                        height: dimension.background ? "100%": apiToZoom(dimension.height + (dimension.svg_json && dimension.svg_json.objects && dimension.svg_json.objects[0].strokeWidth * props.zoomRatio * 2), dimension.is_locked, dimension.background, dimension.height_perc)
                      }}
                      // bounds={inset?".bounds":"parent"}
                      // dragGrid={[4,4]}
                      lockAspectRatio={(dimension.file_format === "text")?false:((props.lockAr)?true:false)}
                      enableResizing={(dimension.background || dimension.file_format === 'svg' || dimension.file_format === 'popup')?(false):(true)}
                      disableDragging={( dimension.file_format === 'svg' || dimension.background||editorOn.current||dimension.change_lock||(props.activeDisplay.id !== props.defaultDisplay && dimension.is_locked))?(true):(false)}
                      onDragStart={(e) => {
                        //   if (layerClickCooldownRef.current) {
                        //   return;
                        // }
                        // // Engage 1s cooldown
                        // layerClickCooldownRef.current = true;
                        // setTimeout(() => {
                        //   layerClickCooldownRef.current = false;
                        // }, 1000);

                        props.showSettings(dimension.id, false, e)
            
                      }}
                      onDrag={(e, d) => {
                        isDragging.current = true;
                      }}
                      onDragStop = {(e, d) => { 
                        var newComponents = [ ...props.componentDimensions ];
                        var newObj = newComponents.find(obj => (obj.id === dimension.id));
                        if ((newObj['x_pos'] !== zoomToApi(d.x, dimension.is_locked))&&(newObj['y_pos']!==zoomToApi(d.y, dimension.is_locked))) {
                          let x = d.x;
                          let y = d.y;
                          if (inset) {
                            if (x < apiToZoom(inset.inset_x, null) && x <= apiToZoom(inset.inset_width, null)) {
                              x = apiToZoom(inset.inset_x,null)
                            } else if (x > apiToZoom(inset.inset_width-dimension.width+inset.inset_x, null)) {
                              x = apiToZoom(inset.inset_width - dimension.width+inset.inset_x,null)
                            } else {
                              // pass
                            }

                            if (y < apiToZoom(inset.inset_y, null) && y <= apiToZoom(inset.inset_height, null)) {
                              y = apiToZoom(inset.inset_y,null)
                            } else if (y > apiToZoom(inset.inset_height-dimension.height+inset.inset_y, null)) {
                              y = apiToZoom(inset.inset_height - dimension.height+inset.inset_y,null)
                            } else {
                              // pass
                            }
                            
                          }
                          newObj['x_pos'] = zoomToApi(x, dimension.is_locked);
                          newObj['y_pos'] = zoomToApi(y, dimension.is_locked);
                          setTimeout(() => {
                            if (newObj) {
                              try {
                                document.getElementById('x_pos_dim_' + dimension.id).value = newObj['x_pos'];
                                document.getElementById('y_pos_dim_' + dimension.id).value = newObj['y_pos']; 
                              } catch (error) {
                                console.error('obj not found', 'x_pos_dim_' + dimension.id, 'y_pos_dim_' + dimension.id)
                              }
                              
                            }
                          }, 100);
                          props.setComponentDimensions(newComponents);
                          props.setUnSavedChanges(true);
                        }
                      
                        setTimeout(() => {
                          isDragging.current = false;
                        }, 300);
                      }}
                      onResizeStop={(e, direction, ref, delta, position) => {

                        var newComponents = [ ...props.componentDimensions ];
                        var newObj = newComponents.find(obj => (obj.id === dimension.id));
                        if (newObj) {
                          newObj['width'] = zoomToApi(ref.offsetWidth, dimension.is_locked);
                          newObj['height'] = zoomToApi(ref.offsetHeight, dimension.is_locked);
                          newObj['x_pos'] = zoomToApi(position.x, dimension.is_locked);
                          newObj['y_pos'] = zoomToApi(position.y, dimension.is_locked);
                          
                          setTimeout(() => {
                            if (newObj) {
                              if (document.getElementById('x_pos_dim_' + dimension.id)){
                                document.getElementById('x_pos_dim_' + dimension.id).value = newObj['x_pos']
                              }
                              if (document.getElementById('y_pos_dim_' + dimension.id)) {
                                document.getElementById('y_pos_dim_' + dimension.id).value = newObj['y_pos'];
                              }
                              if (document.getElementById('width_dim_' + dimension.id)){
                                document.getElementById('width_dim_' + dimension.id).value = newObj['width'];
                              }
                              if (document.getElementById('height_dim_' + dimension.id)){
                                document.getElementById('height_dim_' + dimension.id).value = newObj['height'];
                              }
                              
                              
                            }
                          }, 100);
                          props.setComponentDimensions(newComponents);
                          props.setUnSavedChanges(true);
                        }
                        
                      }}
                      >
                      <div 
                      style={{transform: 'rotate(' + dimension.rotation + 'deg)', transformOrigin: "top left"}}
                      className={
                        "mediaThumb draggable" + 
                        (((props.activeSettingId === dimension.id) && (dimension.file_format !== 'svg')) ?" focus":"") + 
                        ((props.multiSelectIds.includes(dimension.id) && (props.multiSelectIds.length > 1)) ? 
                        " focus multi":"") + (((dimension.html_text && editorOn.current && dimension.file_format === "text" && props.activeSettingId === dimension.id)?" text"
                        :"")) +
                        (dimension.background ? " bkgLayer":"")
                        
                        } 
                        id={"card_" + dimension.id}>
                        <div 
                          className={"canvas-card" + ((editorOn.current === dimension.id )?" open":"")}
                          id={"cardInner_" + dimension.id}
                          data-ordering={dimension.component_ordering}
                          >
                      
                          <span className="resizer topLeft"></span>
                              <span className="resizer topRight"></span>
                              <span className="resizer bottomRight"></span>
                              <span className="resizer bottomLeft"></span>
                            <div className="canvas-card-inner">
                              
                              <div 
                              className="draggableImage canvas-card-front editorLayer"
                              
                              >

                            
                  
                                    { props.stateImages.filter(cdsi => parseInt(cdsi.state_id) === props.activeStateId && cdsi.componentdimension === dimension.id && cdsi.image).map((obj, i) => (
                                        <img
                                        key={'stateImg'+i}
                                        draggable="false"
                                        className={"imgDefault"}
                                        src={obj.image_path}
                                        alt=""
                                      />
                                      ))

                                    }

                                    { props.stateImages.filter(cdsi => (parseInt(cdsi.state_id) === props.activeStateId) && (cdsi.componentdimension === dimension.id) && cdsi.video).map((obj, i) => (
                                        <video 
                                        key={'stateImg'+i}
                                        draggable="false" 
                                        className="vidDefault"
                                        width={apiToZoom(dimension.width, dimension.is_locked)}
                                        height={apiToZoom(dimension.height, dimension.is_locked)}
                                        playsInline
                                        >
                                    
                                          <source src={obj.video_path} type="video/mp4" />
                                        </video>
                                      
                                      ))

                                    }
                                    
                                
                                  {(
                                  ((dimension.file_format === 'img')
                                    && (props.stateImages.filter(cdsi => parseInt(cdsi.state_id) === props.activeStateId).length < 1 && dimension.background === false))
                                  ||(dimension.file_format === 'statePNGButton')) && (
                                    <img
                                      draggable="false"
                                      className={"imgDefault" + ((props.activeStateId === dimension.component_id)?" on":"")}
                                      src={(props.activeStateId === dimension.component_id)?(dimension.image_on_path?dimension.image_on_path:dimension.image_path):(dimension.image_path)}
                                      style={{opacity: dimension.opacity/100}}
                                      alt=""
                                    />
                                  )}

                                  {dimension.background_color && dimension.file_format === 'img' && dimension.image_path === "" && <span className="backgroundColor" style={{backgroundColor: dimension.background_color, width: '100%', height: '100%'}} />}

                                  {(
                                    ((dimension.file_format === 'img' && dimension.image_path !== ""))) && (
                                      <img
                                        draggable="false"
                                        className={"imgDefault"}
                                        src={(props.activeStateId === dimension.component_id)?(dimension.image_on_path?dimension.image_on_path:dimension.image_path):(dimension.image_path)}
                                        style={{opacity: dimension.opacity/100}}
                                        alt=""
                                      />
                                    )}
                                  
                                    {(
                                    ((dimension.file_format === 'popup'))) && (
                                      <img
                                        draggable="false"
                                        className={"imgDefault"}
                                        src={dimension.svg_path}
                                        style={{opacity: dimension.opacity/100}}
                                        alt=""
                                      />
                                    )}
                          


                                  {((dimension.id !== props.activeSettingId) && (dimension.file_format === 'svg')) && (
                                    <span 
                                    className={classNames("paperBox")}
                                    style={{opacity: dimension.opacity/100}}
                                    >
                                    <PaperCanvas 
                                    user={props.user} 
                                    width={(dimension.id !== props.activeSettingId) ? apiToZoom(dimension.width):apiToZoom(props.activeDisplay.width_px)} 
                                    height={(dimension.id !== props.activeSettingId) ? apiToZoom(dimension.height) : apiToZoom(props.activeDisplay.height_px)} 
                                    objWidth={apiToZoom(dimension.width)}
                                    objHeight={apiToZoom(dimension.height)}
                                    handleLayerAdded={props.handleLayerAdded}
                                    zoomRatio={zoomRatio}
                                    svgString={dimension.svg_string}
                                    svgJSON={dimension.svg_json}
                                    x_pos={dimension.x_pos}
                                    y_pos={dimension.y_pos}
                                    editing={false}
                                    objId={dimension.id}
                                    escClear={escClear}
                                    rotation={dimension.rotation}
                                    zoomNumber={props.zoomNumber}
                                    // reloadFrame={props.reloadFrame}
                                    // reRender={reRender}
                                    /> 
                                    </span>
                                    )}

                                  {(dimension.file_format === 'vid') && (
                                    <video 
                                    draggable="false" 
                                    className="vidDefault"
                                    width={apiToZoom(dimension.width, dimension.is_locked)}
                                    height={apiToZoom(dimension.height, dimension.is_locked)}
                                    playsInline
                                    style={{opacity: dimension.opacity/100}}
                                    >
                                      <source src={dimension.video_path} type="video/mp4" />
                                    </video>
                                    )}
                                  
                                    {((dimension.file_format === "text")&&(dimension.html_text)) && 
                                    <span 
                                      name="textValue" 
                                      className={"canvasText" + ((editorOn.current === dimension.id )?"":" readOnly")} 
                                      contentEditable={(editorOn.current === dimension.id)?true:false} 
                                      suppressContentEditableWarning={true} 
                                      onKeyUp={(e) => updateTextOnKeyUp(e)}
                                      onKeyDown={(e) => updateTextonKeyDown(e)}
                                      onSelect={() => {(editorOn.current === dimension.id ) && onSelectStart(
                                        dimension.html_text, 
                                        dimension.id,
                                        props.tempText
                                      )}}
                                      onCopy={(e) => handleCopy(e)}
                                      onPaste={(e) => handlePaste(e)}
                                      // onDoubleClick={(e) => makeTextEditable(e)} 
                                      id={"dim_text_" + dimension.id}
                                      data-fontsize={dimension.html_text.css['font-size']}
                                      style={processCSS(dimension.html_text.css, (insetZoomRatio ? insetZoomRatio : props.zoomRatio), dimension.opacity)}
                                      dangerouslySetInnerHTML={{__html: 
                                        processHtmlText(
                                          dimension.html_text, 
                                          props.zoomRatio, 
                                          "dim_text_" + dimension.id,
                                          props.tempText
                                        )}}>
                                    
                                      </span>
                                      
                                    }
                                    {((dimension.file_format === "text")&&(dimension.html_text)) && selectSpan && selectSpan.filter(n => n.id === dimension.id).map((o, i) => <span className="selectSpan" id={"span_" + o.id + "_" + i} data-elem={"dim_text_" + dimension.id} key={'span_' + i} style={o.style} />)}
                                    
                          
                                
                              </div>
                      
                            </div>
                          </div>
                      </div>
                    </Rnd>)
                  
                  )}
    
                  {!props.activeSectionObj && props.narrative && <img src={Config.mediaURL + props.narrative.screenshot} className="screenshot" alt="" />}
                
                </div>
                    
              </div>
            
            </div>
          
          </div>
          
                    
        </div>
      </div>
    )
}

export default Frame;

//     <PaperCanvas />
// <SvgFreehand />